<div [style.visibility]="visible ? 'visible' : 'hidden'" fxLayout="row" fxLayoutAlign="start center" aria-live="polite" class="jvt-message" 
     [ngClass]="{'jbg-primary': (severity === messageSeverityType.Info),
                 'jvt-messages-warn': (severity === messageSeverityType.Warning),
                 'bg-warn': (severity === messageSeverityType.Error),
                 'jvt-messages-success': (severity === messageSeverityType.Success)}">

    <mat-icon class="jvt-message-icon blink">{{matIcon}}</mat-icon>
    <span class="jvt-message-text blink">{{message | translate}}</span>

</div>